export default __webpack_public_path__ + "static/media/sin_lectinas.6f0e65ba.svg";